/* eslint-disable import/prefer-default-export */

// Material
export const MATERIAL_UNTITLED_SECTION = 'Untitled section';
